import { CLICKED_PRESCRIPTION_ID, PRESCRIPTION_IMAGE_OPEN, PRESCRIPTION_REQUEST, PRESCRIPTION_REQUEST_ERROR, PRESCRIPTION_REQUEST_SUCCESS } from './Constants';

export const prescriptionRequest = (page) => ({
    type: PRESCRIPTION_REQUEST,
    page : page
});

export const prescriptionRequestSuccess = (data, page) => ({
    type: PRESCRIPTION_REQUEST_SUCCESS,
    payload : data,
    page: page
});

export const prescriptionRequestError = () => ({
    type: PRESCRIPTION_REQUEST_ERROR,
});

export const clickedPrescriptionIdRequest = (prescriptionId) => ({
    type: CLICKED_PRESCRIPTION_ID,
    prescriptionId : prescriptionId
});

export const prescriptionImageRequest = (url) => ({
    type: PRESCRIPTION_IMAGE_OPEN,
    url : url
});
